import _ from 'lodash'

export default {
  namespaced: true,
  state: {
    livingOptions: [],
    subsections: [],
    properties: [],
    dwellings: [],
    packages: [],
    turnkeys: [],

    activeSlideId: '',

    activeVirtualTourUrl: ''
  },

  mutations: {
    SET_LIVING_OPTIONS (state, livingOptions) {
      state.livingOptions = livingOptions
    },

    SET_SUBSECTIONS (state, subsections) {
      state.subsections = subsections
    },

    SET_PROPERTIES (state, properties) {
      state.properties = properties
    },

    SET_DWELLINGS (state, dwellings) {
      state.dwellings = dwellings
    },

    SET_TURNKEYS (state, turnkeys) {
      state.turnkeys = turnkeys
    },
    
    SET_PACKAGES (state, packages) {
      state.packages = packages
    },

    SET_ACTIVE_SLIDE_ID: (state, id) => {
      state.activeSlideId = id
    },

    SET_ACTIVE_VIRTUAL_TOUR_URL: (state, id) => {
      state.activeVirtualTourUrl = id
    },
  },

  getters: {
    activeSlide: (state) => {
      const slide = state.packages.find(_package => _package._id === state.activeSlideId)

      if (slide) {
        return slide

      } else {
        return null
      }
    },

    activeLivingOption: (state, getters, rootState) => {
      const livingOptionId = rootState.route.params.livingOptionId

      if (livingOptionId) {
        return _.find(getters.livingOptions, livingOption => {
          return livingOption._id === livingOptionId
        })
      } else {
        return null
      }
    },

    activeLivingOptionSubsections (state, getters, rootState) {
      const routeName = rootState.route.name

      if (['living-option', 'subsection'].includes(routeName)) {        
        return _.sortBy(getters.activeSubsections, subsection => {
          return subsection.marker.x
        })
      }
      
      return []
    },

    activeLivingOptionProperties (state, getters, rootState) {
      const routeName = rootState.route.name

      if (['subsection', 'property'].includes(routeName)) {
        return _.sortBy(getters.activeProperties, property => {
          return property.marker.x + property.marker.y
        })
      }

      if (rootState.route.name === 'live-display-homes' || rootState.route.name === 'live-display-homes-property') {
        return _.sortBy(getters.activeProperties, property => {
          return property.marker.x + property.marker.y
        })
      }  
      
      return []
    },

    activeLivingOptionTags (state, getters, rootState) {
      const routeName = rootState.route.name
      const pathway = rootState.route.params.pathway

      if (['living-entry'].includes(routeName)) {
        if (pathway === 'land') {
          return _.sortBy(getters.livingOptionsLand, livingOption => {
            return livingOption.marker.x
          })
        }

        if (pathway === 'townhouses') {
          return _.sortBy(getters.livingOptionsTownhouses, livingOption => {
            return livingOption.marker.x
          })
        }

        if (pathway === 'apartments') {
          return _.sortBy(getters.livingOptionsApartments, livingOption => {
            return livingOption.marker.x
          })
        }

        if (pathway === 'houses') {
          return _.sortBy(getters.livingOptionsHouses, livingOption => {
            return livingOption.marker.x
          })
        }
      }
      
      return []
    },

    activeProperty: (state, getters, rootState) => {
      if (rootState.route.params.propertyId) {
        let property = _.find(getters.properties, property => {
          return property._id === rootState.route.params.propertyId
        })

        const associatedPackages = state.packages.filter(_package => {
          return _package.active && _package.property.label === property.label
        })

        property['associatedPackages'] = associatedPackages

        return property
      } else {
        return null
      }
    },

    activeProperties: (state, getters) => {
      return getters.activeSubsection ? getters.activeSubsection.properties : []
    },

    activeSubsection: (state, getters, rootState) => {      
      if (rootState.route.params.livingOptionId && rootState.route.params.subsectionId) {
        return _.find(getters.subsections, subsection => {
          return subsection._id === rootState.route.params.subsectionId
        })
      } else if (rootState.route.name === 'live-display-homes' || rootState.route.name === 'live-display-homes-property') {
        return _.find(getters.subsections, subsection => {
          return subsection.isDisplayVillage
        })
      } else {
        return null
      }
    },

    activeSubsections: (state, getters, rootState) => {      
      const pathway = rootState.route.params.pathway

      let activeSubsections = []

      if (getters.activeSubsection) {
        getters.activeSubsection.subsectionIds.forEach(subsectionId => {
          const activeSubsection = _.find(getters.subsections, subsection => { return subsection._id === subsectionId && subsection.type === pathway })
          if (activeSubsection) {
            activeSubsections.push(activeSubsection)
          }
        })
  
        return activeSubsections
      }

      if (getters.activeLivingOption) {
        getters.activeLivingOption.subsectionIds.forEach(subsectionId => {
          const activeSubsection = _.find(getters.subsections, subsection => { return subsection._id === subsectionId && subsection.type === pathway })
          if (activeSubsection) {
            activeSubsections.push(activeSubsection)
          }
        })
  
        return activeSubsections
      }

      return []
    },

    activeVirtualTourUrl: (state) => {
      return state.activeVirtualTourUrl
    },

    livingOptions: (state) => {
      return state.livingOptions
    },

    livingOptionsApartments: (state, getters, rootState, rootGetters) => {
      if (getters.livingOptions.length) {
        return getters.livingOptions.filter(livingOption => {
          let show = false

          // show if living option subsections contain land
          livingOption.subsections && livingOption.subsections.forEach(subsection => {
            if (subsection.type === 'apartments') {
              show = true
            }
          })

          // hide if sold out
          if (livingOption.availablePropertiesCount === 0 && !rootGetters.styleTemplate['general']['show-sold-neighbourhoods']) {
            show = false
          }
          
          return show
        })
      } else {
        return []
      }
    },   

    livingOptionsHouses: (state, getters, rootState, rootGetters) => {
      if (getters.livingOptions.length) {
        return getters.livingOptions.filter(livingOption => {
          let show = false

          // show if living option subsections contain land
          livingOption.subsections && livingOption.subsections.forEach(subsection => {
            if (subsection.type === 'houses') {
              show = true
            }
          })

          // hide if sold out
          if (livingOption.availablePropertiesCount === 0 && !rootGetters.styleTemplate['general']['show-sold-neighbourhoods']) {
            show = false
          }
          
          return show
        })
      } else {
        return []
      }
    },    

    livingOptionsLand: (state, getters, rootState, rootGetters) => {
      if (getters.livingOptions.length) {
        return getters.livingOptions.filter(livingOption => {
          let show = false

          // show if living option subsections contain land
          livingOption.subsections && livingOption.subsections.forEach(subsection => {
            if (subsection.type === 'land') {
              show = true
            }
          })

          // hide if sold out
          if (livingOption.availablePropertiesCount === 0 && !rootGetters.styleTemplate['general']['show-sold-neighbourhoods']) {
            show = false
          }
          
          return show
        })
      } else {
        return []
      }
    },

    livingOptionsTownhouses: (state, getters, rootState, rootGetters) => {
      if (getters.livingOptions.length) {
        return getters.livingOptions.filter(livingOption => {
          let show = false

          // show if living option subsections contain land
          livingOption.subsections && livingOption.subsections.forEach(subsection => {
            if (subsection.type === 'townhouses') {
              show = true
            }
          })

          // hide if sold out
          if (livingOption.availablePropertiesCount === 0 && !rootGetters.styleTemplate['general']['show-sold-neighbourhoods']) {
            show = false
          }
          
          return show
        })
      } else {
        return []
      }
    },

    livingOptionsPackages: (state) => {
      return state.packages
    },

    packages: (state) => {
      return state.packages
    },

    livingOptionsDwellings: (state) => {
      return state.dwellings
    },

    land: state => {
      if (state.properties.length) {
        let land = _.filter(state.properties, property => !property.dwelling)
        return land
      }
    },

    townhouses: (state) => {
      if (state.properties.length) {
        let townhouses = _.filter(state.properties, property => property.dwelling && property.dwelling.type === 'townhouse') 
        return townhouses
      }
    },

    apartments: (state) => {
      if (state.properties.length) {
        let apartments = _.filter(state.properties, property => property.dwelling && property.dwelling.type === 'apartments') 
        return apartments
      }
    },

    houses: (state) => {
      if (state.properties.length) {
        let houses = _.filter(state.properties, property => property.dwelling && property.dwelling.type === 'house') 
        return houses
      }
    },

    properties: (state) => {
      return state.properties
    },

    dwellings: (state) => {
      return state.dwellings
    },

    turnkeys: (state) => {
      return state.turnkeys
    },

    // Returns an array of Subsection objects with their associated Properties nested inside
    // Also sets a "filter" flag to true if all properties have been filtered out
    // Also handles nested subsections
    subsections: (state) => {
      return state.subsections
    },
  }
}
